<div class="orders-panel">
  <div *ngIf="loadingPage" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <div #containerScroll class="bg-transparent" (scroll)="isScrolledInfinityView($event)">
    <!-- Vista de tabla para desktop -->
    <div class="desktop-view d-none d-lg-block table-orders table-panel multiple-lines">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z28 desktop-view" matSort
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef class=""><b>
              <div class="d-flex align-items-center" style="gap: 10px;">
                <mat-checkbox [(ngModel)]="allSelected" class="checkbox" color="primary" (change)="selectAll()"
                  *ngIf="activeSelectList"></mat-checkbox>
                <span *ngIf="!activeSelectList">Acciones</span>
              </div>
            </b></th>
          <td mat-cell *matCellDef="let order" class="">
            <div class="d-flex align-items-center" style="gap: 10px;">
              <mat-checkbox class="checkbox" [checked]="allSelected" color="primary" (change)="changeSelectItem(order)"
                *ngIf="activeSelectList"></mat-checkbox>

              <div class="d-flex" style="gap: 30px;" *ngIf="!activeSelectList">
                <div [matMenuTriggerFor]="actionOptions" style="width: 20px;"
                  class="pointer-in d-flex justify-content-center">
                  <i class="icon-option fal fa-ellipsis-vertical"></i>
                </div>
                <mat-menu class="options-menu-control-panel" #actionOptions="matMenu">
                  <button mat-menu-item class="deleteIcon" (click)="openOrder(order.id)">Ver</button>
                  <!-- <button mat-menu-item class="deleteIcon" (click)="cancelPendingOrder(order)"
                                    *ngIf="order.status?.short_name == 'pending' && allowCancel">Cancelar</button> -->
                  <button mat-menu-item class="deleteIcon" (click)="downloadTicketOrder(order.id, 'a4')"
                    *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && !order.is_season_pass_order">Imprimir
                    A4</button>
                  <button mat-menu-item class="deleteIcon" (click)="downloadTicketOrder(order.id, 'ticket')"
                    *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && !order.is_season_pass_order">Imprimir
                    ticket</button>
                  <button mat-menu-item class="deleteIcon" (click)="sendEmailConfirm(order)"
                    *ngIf="order.status?.short_name == 'paid' && !order.is_season_pass_order">Volver a enviar entradas</button>
                  <button mat-menu-item class="deleteIcon" (click)="cancelOrder(order)"
                    *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && canRefundOrder(order)">Devolver
                    pedido</button>
                </mat-menu>
                <i class="icon-option fal fa-print icon-primary pointer-in"
                  [class.disabled-download]="(order.status?.short_name != 'paid' && order.status?.short_name != 'partial_refund') || order.is_season_pass_order"
                  (click)="downloadTicketOrder(order.id, 'a4')"></i>
                <i class="icon-option fal fa-ticket icon-primary pointer-in"
                  [class.disabled-download]="(order.status?.short_name != 'paid' && order.status?.short_name != 'partial_refund') || order.is_season_pass_order"
                  (click)="downloadTicketOrder(order.id, 'ticket')"></i>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>ID Pedido</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            <div class="d-flex align-items-center flex-wrap" style="gap: 8px;">
              <span>{{order.invoice_number||'-'}}</span>
              <!-- Reservas generadas al publicar el evento para un abonado: no son
                   una venta, y sin la marca no habría cómo distinguirlas en la lista. -->
              <span class="pill-abonado" *ngIf="order.is_season_pass_order">
                <i class="fa-light fa-id-card"></i> Abonado
              </span>
            </div>
          </td>
        </ng-container>
        <!-- Id de la transacción en el TPV: es el mismo número de pedido que
             viaja a Redsys, así que es por el que se busca el cobro en el banco. -->
        <ng-container matColumnDef="id_invoicing">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>ID de transacción</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{order.id_invoicing || '-'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Nombre y apellidos</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{order.cart.user.name||'-'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Correo electrónico</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{order.cart.user.email||'-'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="channel">
          <th mat-header-cell *matHeaderCellDef><b>Canal</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{getChannelName(order.id_channel)}}
          </td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Fecha y hora trans.</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{order.created_at | date: 'dd/MM/yyyy HH:mm'}} h
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Precio</b></th>
          <td mat-cell *matCellDef="let order" (click)="openOrder(order.id)">
            {{(order.total_order?.total ?? (+order.total - +(order.discount_total ?? 0) + +(order.total_fee ?? 0))) | number:'1.2-2'}} €
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef><b>Estado</b></th>
          <td mat-cell *matCellDef="let order" (click)="openInfoPayment(order)">
            <div class="d-flex align-items-center" style="gap: 5px;">
              <i class="fas fa-circle" [style.color]="getColorStatus(order.status.short_name)"></i>
              <span [style.color]="getColorStatus(order.status.short_name)">{{order.status.name||'-'}}</span>
              <i class="fal fa-memo-circle-info"></i>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>


    <!-- Vista de tarjetas para móvil -->
    <div class="mobile-view d-block d-lg-none px-2">
      <div class="row">
        <div class="col-12 col-md-6" *ngFor="let order of dataSource.data">
          <div class="order-card" (click)="openOrder(order.id)">
            <div class="order-card-header">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center flex-wrap" style="gap: 8px;">
                  <span class="order-id">Pedido #{{order.invoice_number||'-'}}</span>
                  <span class="pill-abonado" *ngIf="order.is_season_pass_order">
                    <i class="fa-light fa-id-card"></i> Abonado
                  </span>
                </div>
                <div class="order-actions d-flex align-items-center" style="gap: 24px;"
                  (click)="$event.stopPropagation()">
                  <i class="icon-option fal fa-print text-primary pointer-in"
                    [class.disabled-download]="(order.status?.short_name != 'paid' && order.status?.short_name != 'partial_refund') || order.is_season_pass_order"
                    (click)="downloadTicketOrder(order.id, 'a4')"></i>
                  <i class="icon-option fal fa-ticket text-primary pointer-in"
                    [class.disabled-download]="(order.status?.short_name != 'paid' && order.status?.short_name != 'partial_refund') || order.is_season_pass_order"
                    (click)="downloadTicketOrder(order.id, 'ticket')"></i>
                  <div [matMenuTriggerFor]="actionOptions" class="pointer-in">
                    <i class="icon-option fal fa-ellipsis-vertical"></i>
                  </div>
                  <mat-menu class="options-menu-control-panel" #actionOptions="matMenu">
                    <button mat-menu-item (click)="openOrder(order.id)">Ver</button>
                    <button mat-menu-item (click)="downloadTicketOrder(order.id, 'a4')"
                      *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && !order.is_season_pass_order">
                      Imprimir A4
                    </button>
                    <button mat-menu-item (click)="downloadTicketOrder(order.id, 'ticket')"
                      *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && !order.is_season_pass_order">
                      Imprimir ticket
                    </button>
                    <button mat-menu-item (click)="sendEmailConfirm(order)"
                      *ngIf="order.status?.short_name == 'paid' && !order.is_season_pass_order">
                      Volver a enviar entradas
                    </button>
                    <button mat-menu-item (click)="cancelOrder(order)"
                      *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && canRefundOrder(order)">
                      Devolver pedido
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
            <div class="order-card-body">
              <div class="order-detail" *ngIf="order.id_invoicing">
                <span class="label">ID de transacción:</span>
                <span class="value">{{order.id_invoicing}}</span>
              </div>
              <div class="order-detail">
                <span class="label">Cliente:</span>
                <span class="value">{{order.cart.user.name||'-'}}</span>
              </div>
              <div class="order-detail">
                <span class="label">Email:</span>
                <span class="value">{{order.cart.user.email||'-'}}</span>
              </div>
              <div class="order-detail">
                <span class="label">Canal:</span>
                <span class="value">{{getChannelName(order.id_channel)||'-'}}</span>
              </div>
              <div class="order-detail">
                <span class="label">Fecha:</span>
                <span class="value">{{order.created_at | date: 'dd/MM/yyyy HH:mm'}} h</span>
              </div>
              <div class="order-detail">
                <span class="label">Total:</span>
                <span class="value price">{{(order.total_order?.total ?? (+order.total - +(order.discount_total ?? 0) + +(order.total_fee ?? 0))) | number:'1.2-2'}} €</span>
              </div>
              <div class="order-detail" (click)="openInfoPayment(order); $event.stopPropagation()">
                <span class="label">Estado:</span>
                <div class="d-flex align-items-center" style="gap: 5px;">
                  <i class="fas fa-circle" [style.color]="getColorStatus(order.status.short_name)"></i>
                  <span [style.color]="getColorStatus(order.status.short_name)">{{order.status.name||'-'}}</span>
                  <i class="fal fa-memo-circle-info"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>


  </div>
  <div class="pagination-component">
    <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
      <div>
        <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}" *ngIf="!loaded"
          containerClass="loading-box"></ng-lottie>
      </div>
    </div>
  </div>
  <p *ngIf="loaded && !loadingPage && orders?.length <= 0" style="text-align: center; margin-top: 80px;">No hay
    pedidos disponibles</p>

</div>
